import { deriveImageryGroups } from "./deriveImageryGroups";
import { LAYER_GROUPS_STATIC } from "./layerPanelConfigStatic";

export function buildLayerGroups({ imageryLayers = [], userRole }) {
  return [
    ...deriveImageryGroups({ layers: imageryLayers, userRole }),
    ...LAYER_GROUPS_STATIC,
  ];
}